<form *ngIf="!isLoading">
    <label class="toggle-switch clearfix" *ngIf="showSettings.createLayerForEachGraphic">
        <span class="togggle-switch-label left font-size--1">Create a seperate layer for each graphic</span>
        <input type="checkbox" name="seperate" class="toggle-switch-input" [(ngModel)]="createLayerForEachGraphic"
               checked>
        <span class="toggle-switch-track right"></span>
    </label>
    <div class="setting" *ngIf="showSettings.type">
        <label for="type">Type</label>
        <select id="type" class="select-full" name="type" [(ngModel)]="selectedPolygonType" (ngModelChange)="reset()">
            <option *ngFor="let option of polygonTypes" [ngValue]="option">{{ option.name }}</option>
        </select>
    </div>
    <div class="setting" *ngIf="showSettings.mode">
        <label for="mode">Mode</label>
        <select id="mode" class="select-full" name="mode" [(ngModel)]="selectedPolygonMode" (ngModelChange)="reset()">
            <option *ngFor="let option of polygonModes" [ngValue]="option" [title]="option.description" [disabled]="option.disabled">{{ option.name }}</option>
        </select>
    </div>
    <div class="setting" *ngIf="showSettings.fillStyle">
        <label for="style">Fill Style</label>
        <select id="style" class="select-full" name="style" [(ngModel)]="symbolProperties.style">
            <option *ngFor="let option of fillStyleOptions" [value]="option.value">{{ option.name }}</option>
        </select>
    </div>

    <div class="setting" *ngIf="showSettings.fillColor">
        <label for="color" (click)="colorPicker.showColorPicker = true;">Fill Color</label>
        <mc-color-picker-ng #colorPicker
                            [(color)]="symbolProperties.color"
                            [siblingColorPickers]="[outlineColorPicker]">
        </mc-color-picker-ng>
    </div>

    <div class="setting" *ngIf="showSettings.outlineStyle">
        <label for="outline-style">Outline Style</label>
        <select id="outline-style" class="select-full" name="outlineStyle"
                [(ngModel)]="symbolProperties.outline.style">
            <option *ngFor="let option of outlineStyleOptions" [value]="option.value">{{ option.name }}</option>
        </select>
    </div>

    <div *ngIf="!isLineStyleSupportedForPrinting" class="alert alert-yellow is-active info-div">
        <b>Warning:</b> This outline style is not supported for printing, and will be replaced with {{ replacementLineStyle }} in the printed map.
    </div>

    <div class="setting" *ngIf="showSettings.outlineWidth">
        <label for="outline-width">Outline Width</label>
        <input id="outline-width" type="number" name="width" [(ngModel)]="symbolProperties.outline.width" required>
    </div>

    <div class="setting" *ngIf="showSettings.outlineColor">
        <label for="outline-color" (click)="outlineColorPicker.showColorPicker = true;">Outline Color</label>
        <mc-color-picker-ng #outlineColorPicker
                            [(color)]="symbolProperties.outline.color"
                            [siblingColorPickers]="[colorPicker]">
        </mc-color-picker-ng>
    </div>

    <div class="setting" *ngIf="showSettings.areaUnit">
        <label for="unit">Area Unit</label>
        <select id="unit" name="unit" [(ngModel)]="selectedAreaUnit">
            <option *ngFor="let option of areaUnits" [ngValue]="option">{{ option.name }}</option>
        </select>
    </div>
</form>
<div *ngIf="isLoading" class="loader is-active padding-leader-3 padding-trailer-3">
    <div class="loader-bars"></div>
</div>
